import { forwardRef } from "react";
import InputField from "./InputField.js";

const NumberField = forwardRef(function (props, ref) {
  return <InputField type="number" {...props} />;
});
NumberField.displayName = "NumberField";

export default NumberField;
